<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="`Edit: ${account.ClientName} :: MeritEHS`" v-if="SmartBizClientId" />
            <vue-headful :title="`New Account :: MeritEHS`" v-else />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/dev/accounts`">
                            <i class="fa fa-key"></i> MeritEHS Accounts
                        </router-link>
                    </li>
                    <template v-if="SmartBizClientId">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/dev/accounts/view/${account.SmartBizClientId}`">
                                {{ account.ClientName }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            Edit
                        </li>
                    </template>
                    <li class="breadcrumb-item active" v-else>
                        New Account
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <div class="card mb-4">
                        <div class="card-header">Account Details</div>
                        <div class="card-body">
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.ClientName}">Client Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" name="ClientName" v-model="account.ClientName" :class="{'form-control': true, 'is-invalid': errors.ClientName}" placeholder="Enter Client Name (Required)" />
                                    <span v-if="errors.ClientName" class="text-danger">
                                        <span v-for="error in errors.ClientName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.trial_ends_at}">Free Trial Until:</label>
                                <div class="col-sm-8">
                                    <date-picker v-model="account.trial_ends_at" :config="dateTimeOptions" :class="{ 'is-invalid': errors.trial_ends_at }" placeholder="Free Trial Ends At"></date-picker>
                                    <span v-if="errors.trial_ends_at" class="text-danger">
                                        <span v-for="error in errors.trial_ends_at">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.IsActive}">Active:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="account.IsActive" :value="1" :unchecked-value="0" plain />
                                    <span v-if="errors.IsActive" class="text-danger">
                                        <span v-for="error in errors.IsActive">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.has_paid}">Has Paid:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="account.has_paid" :value="1" :unchecked-value="0" plain />
                                    <span v-if="errors.has_paid" class="text-danger">
                                        <span v-for="error in errors.has_paid">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.enable_public_insp_forms}">Enable Public Inspections:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="account.enable_public_insp_forms" :value="1" :unchecked-value="0" plain />
                                    <span v-if="errors.enable_public_insp_forms" class="text-danger">
                                        <span v-for="error in errors.enable_public_insp_forms">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.enable_module_custom_forms}">Enable Custom Forms:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="account.enable_module_custom_forms" :value="1" :unchecked-value="0" plain />
                                    <span v-if="errors.enable_module_custom_forms" class="text-danger">
                                        <span v-for="error in errors.enable_module_custom_forms">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">Sending Credits</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.monthly_email_limit}">Email Credits:</label>
                                <div class="col-sm-7">

                                    <b-form-input v-model="account.monthly_email_limit" :class="{'is-invalid': errors.monthly_email_limit}" placeholder="Enter # of Email Credits"></b-form-input>

                                    <span v-if="errors.monthly_email_limit" class="text-danger">
                                        <span v-for="error in errors.monthly_email_limit">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.monthly_text_limit}">Text Credits:</label>
                                <div class="col-sm-7">

                                    <b-form-input v-model="account.monthly_text_limit" :class="{'is-invalid': errors.monthly_text_limit}" placeholder="Enter # of Text Credits"></b-form-input>

                                    <span v-if="errors.monthly_text_limit" class="text-danger">
                                        <span v-for="error in errors.monthly_text_limit">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <form class="card mb-4" autocomplete="off">
                        <div class="card-header">Account Admin User <i class="fa fa-asterisk text-danger"></i> <small class="text-danger">Required For New Accounts</small></div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.FirstName}">First Name:</label>
                                <div class="col-sm-8">

                                    <b-form-input v-model="user.FirstName" :class="{'is-invalid': errors.FirstName}" placeholder="Enter First Name"></b-form-input>

                                    <span v-if="errors.FirstName" class="text-danger">
                                        <span v-for="error in errors.FirstName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.LastName}">Last Name:</label>
                                <div class="col-sm-8">

                                    <b-form-input v-model="user.LastName" :class="{'is-invalid': errors.LastName}" placeholder="Enter Last Name"></b-form-input>

                                    <span v-if="errors.LastName" class="text-danger">
                                        <span v-for="error in errors.LastName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.username}">Email:</label>
                                <div class="col-sm-8">

                                    <b-form-input v-model="user.username" :class="{'is-invalid': errors.username}" placeholder="Enter Email Address"></b-form-input>

                                    <span v-if="errors.username" class="text-danger">
                                        <span v-for="error in errors.username">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr/>

                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.password}">Password:</label>
                                <div class="col-sm-8">

                                    <input type="password" v-model="user.password" placeholder="Minimum 8 Characters" :class="{'form-control': true, 'is-invalid': errors.password}" autocomplete="new-password" />

                                    <span v-if="errors.password" class="text-danger">
                                        <span v-for="error in errors.password">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.password_confirmation}">Confirm Password:</label>
                                <div class="col-sm-8">

                                    <input type="password" v-model="user.password_confirmation" placeholder="Confirm your password" :class="{'form-control': true, 'is-invalid': errors.password_confirmation}" autocomplete="new-password" />

                                    <span v-if="errors.password_confirmation" class="text-danger">
                                        <span v-for="error in errors.password_confirmation">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr />
                        </div>
                    </form>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" v-on:click="saveAccount()" :disabled="saving">
                <template v-if="account.SmartBizClientId">Update</template>
                <template v-else>Create</template>
                Account
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                SmartBizClientId: this.$route.params.id,
                query: this.$route.query,
                account: {},
                user: {},
                errors: {},
                userTimezone: this.$store.state.user.timezone,
                dateTimeOptions: {
                    format: 'MM/DD/YYYY hh:mm A',
                    useCurrent: false,
                    timeZone: this.$store.state.user.timezone,
                },
                prepaidOptions: {
                    format: 'MM/DD/YYYY',
                    useCurrent: false,
                },
                default_monthly_email_limit: null,
                default_monthly_text_limit: null,
            }
        },

        computed: {

        },


        methods: {

            getAccount: function() {
                //Get the data
                this.$http
                    .get('dev/accounts/edit' + (this.SmartBizClientId ? '/' + this.SmartBizClientId : ''), this.query)
                    .then(response => {
                        //Set all the data
                        this.account = response.data.account;
                        this.default_monthly_email_limit = response.data.default_monthly_email_limit;
                        this.default_monthly_text_limit = response.data.default_monthly_text_limit;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveAccount: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Build the payload
                let payload = {...this.account, ...this.user};

                //Send it
                this.$http
                .post('dev/accounts/edit', payload)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Account Saved');

                    //Return to main list?
                    this.$router.push('/dev/accounts/view/' + response.data.SmartBizClientId);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getAccount();
        }
    }
</script>
